import React, { Component } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Tooltip } from '@mui/material'

export default class IAction extends Component {
    notifs() {
        return ''
    }

    content() {
        return ''
    }

    name() {
        return ''
    }
    id() {
        return uuidv4()
    }


    render() {
        const dropDown = this.content() ? 'dropdown-button' : ''
        return (
            <div className='action-wrapper'>
                <Tooltip title={this.label()} id={this.id()}>
                    <a
                        className={`right waves-effect nav-actions blue-arrow ${dropDown}`}
                        data-activates={this.name()}
                        onClick={ this.fn() }
                        id={this.id()}
                        data-cy={this.id()}
                    >
                        <i className='material-icons left no-margin' id={this.icon()} >{ this.icon() }</i>
                        { this.notifs() }
                    </a>
                </Tooltip>
                { this.content() }
            </div>
        )
    }
}
